import { Outlet } from 'react-router-dom';

export default function NoAutht() {
    return (
        <div className=''>
            <Outlet />
        </div>
    );
}
